import React from 'react';
import { Sparkles, Grid3x3, Anchor, Activity, Zap, Cpu, Smile, Layers, Sparkle, Cross, Circle, Heart, Droplet, Grid2x2, Move } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { services } from '../mock';

export const Services = () => {
  const iconMap = {
    Sparkles: Sparkles,
    Grid3x3: Grid3x3,
    Anchor: Anchor,
    Activity: Activity,
    Zap: Zap,
    Cpu: Cpu,
    Smile: Smile,
    Layers: Layers,
    Sparkle: Sparkle,
    Cross: Cross,
    Circle: Circle,
    Heart: Heart,
    Droplet: Droplet,
    Grid2x2: Grid2x2,
    Move: Move
  };

  return (
    <section id="services" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive dental solutions to meet all your oral health needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const Icon = iconMap[service.icon] || Sparkles;
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-emerald-200 hover:-translate-y-2"
              >
                <CardHeader>
                  <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 w-16 h-16 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon size={32} className="text-emerald-700" />
                  </div>
                  <CardTitle className="text-xl text-gray-900 group-hover:text-emerald-700 transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-sm text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-center gap-2 text-sm text-gray-700">
                        <div className="w-1.5 h-1.5 bg-emerald-600 rounded-full"></div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-20 text-center bg-gradient-to-r from-emerald-50 to-teal-50 rounded-2xl p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">
            Not Sure Which Service You Need?
          </h3>
          <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto">
            Schedule a consultation with our experts. We'll assess your needs and recommend 
            the best treatment plan for your smile.
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors shadow-lg hover:shadow-xl"
          >
            Schedule Consultation
          </button>
        </div>
      </div>
    </section>
  );
};
